export enum InClosingDateTypeEnum {
    Opening= 0,
    InPreClosing = 1,
    InClosing = 2
}